'use client';
interface FreshnessIndicatorProps {
  lastVerified: string;
  className?: string;
}
export function FreshnessIndicator({
  lastVerified,
  className = '',
}: FreshnessIndicatorProps) {
  const date = new Date(lastVerified);
  const now = new Date();
  const daysSince = Math.floor(
    (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24)
  );
  const status =
    daysSince <= 30 ? 'fresh' : daysSince <= 90 ? 'recent' : 'aging';
  const config = {
    fresh: {
      dot: 'bg-green-400',
      wrapper: 'text-green-400 border-green-400/20 bg-green-400/5',
      label: 'Up to date',
    },
    recent: {
      dot: 'bg-yellow-400',
      wrapper: 'text-yellow-400 border-yellow-400/20 bg-yellow-400/5',
      label: 'Verified recently',
    },
    aging: {
      dot: 'bg-red-400',
      wrapper: 'text-red-400 border-red-400/20 bg-red-400/5',
      label: 'Due for review',
    },
  };
  const c = config[status];
  const formatted = date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs border ${c.wrapper} ${className}`}
    >
      <div className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      <span>Data verified: {formatted}</span>
    </div>
  );
}
